"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceType = void 0;
var InsuranceType;
(function (InsuranceType) {
    InsuranceType[InsuranceType["NONE"] = 0] = "NONE";
    InsuranceType[InsuranceType["PARTIAL_COMPREHENSIVE"] = 1] = "PARTIAL_COMPREHENSIVE";
    InsuranceType[InsuranceType["FULLY_COMPREHENSIVE"] = 2] = "FULLY_COMPREHENSIVE";
})(InsuranceType = exports.InsuranceType || (exports.InsuranceType = {}));
//# sourceMappingURL=insurance.js.map